import { isLogin } from '@common/logic/src/login';
import { isMac } from './utils';
import { DefaultLogger } from '@/common/logger';

export enum LoginStatus {
  QQLIVE_LOGIN_STATUS_LOGOUT = 0,
  QQLIVE_LOGIN_STATUS_LOGINING,
  QQLIVE_LOGIN_STATUS_LOGOUTING,
  QQLIVE_LOGIN_STATUS_LOGINED,
}

/**
 * 检查登录状态
 * 未登录，返回false，否则返回true
 * @returns 登录状态
 */
export const checkLogin = () => isLogin();


const isEvo = import.meta.env.EVO;

export const commonOpenLogin = () => {
  try {
    if (isEvo) {
      const qqliveLink = isMac ? 'qqlive://sso/login=1&parent=main' : 'qqlive://sso/changeaccount=1';
      vnContext.external.openQQLive(qqliveLink);
    } else {
      window.txv.login.openLogin();
    }
  } catch (error) {
    DefaultLogger.log(error);
    DefaultLogger.log(`${isEvo ? '客户端' : ' web端'}拉起登录失败`);
  }
};


// EVO端获取用户方法
export const getEvoUserInfo = async () => {
  if (!isEvo) {
    return {};
  }
  return await vnContext?.external?.getUserInfo?.() || vn?.external?.getUserInfo?.();
};

// WEB端获取用户方法
export const getWebUserInfo = async () => {
  const isLogin = window.txv.login.isLogin();
  DefaultLogger.log(isLogin);
  const loginInfo = await window.txv.login?.getLoginInfo?.();

  return {
    loginInfo,
  };
};

